<div class="container neptune-margin mb-neptune-bar" [ngClass]="{'border box-border-bg box-shadow': border === true}">
    <div class="title" *ngIf="title != undefined">{{ title }}</div>
    <ng-content></ng-content>
</div>
<br/>
&nbsp;
